import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from '@app/material.module';
// import { StatusrkiComponent } from './statusrki/statusrki.component';
import { EinurllandComponent } from './einurlland/einurlland.component';
import { InzidenzComponent } from './inzidenz/inzidenz.component';
import { EinnachdeuschComponent } from './einnachdeusch/einnachdeusch.component';
import { AusamtComponent } from './ausamt/ausamt.component';
import { RegelungenComponent } from './regelungen/regelungen.component';
import { AngeboteComponent } from './angebote/angebote.component';
// import { ReisecoronaComponent } from './reisecorona/reisecorona.component';
// import { CoronaupdatesComponent } from './coronaupdates/coronaupdates.component';
import { PipeModule } from '@app/pipe/pipe.module';
import { DirectiveModule } from '@app/directives/directive.module';

@NgModule({
    declarations: [
        // StatusrkiComponent,
        EinurllandComponent,
        InzidenzComponent,
        EinnachdeuschComponent,
        AusamtComponent,
        RegelungenComponent,
        AngeboteComponent,
        // ReisecoronaComponent,
        // CoronaupdatesComponent
    ],
    exports: [
        // StatusrkiComponent,
        EinurllandComponent,
        InzidenzComponent,
        EinnachdeuschComponent,
        AusamtComponent,
        RegelungenComponent,
        AngeboteComponent,
        DirectiveModule,
        // ReisecoronaComponent,
        // CoronaupdatesComponent
    ],
    imports: [
        CommonModule,
        PipeModule,
        AngularMaterialModule
    ]
})
export class ReisecompassModule { }
